
  var _styles = {
  "container": {
    "borderRadius": "0.21333rem",
    "backgroundColor": "rgb(255,255,255)",
    "display": "flex",
    "alignItems": "center",
    "marginRight": "0.16rem",
    "position": "relative"
  },
  "bizLineContainer": {
    "position": "absolute",
    "top": 0,
    "left": 0,
    "height": "0.42667rem",
    "display": "flex",
    "flexDirection": "row"
  },
  "bizLineBg": {
    "height": "0.42667rem",
    "backgroundColor": "rgb(255,241,240)",
    "paddingTop": 0,
    "paddingRight": "0.13333rem",
    "paddingBottom": 0,
    "paddingLeft": "0.13333rem",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "bizLineText": {
    "color": "rgb(255,75,16)",
    "fontFamily": "PingFang SC",
    "fontWeight": "400",
    "fontSize": "0.29333rem",
    "lineHeight": "0.26667rem"
  },
  "contentContainer": {
    "display": "flex",
    "justifyContent": "space-between",
    "alignItems": "center"
  },
  "amoutContainer": {
    "height": "0.69333rem",
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "amoutContainerTop": {
    "height": "0.69333rem",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "flex-end"
  },
  "amoutLeft": {
    "color": "rgb(17,17,17)",
    "fontFamily": "MTNewDigitalDisplay-Bold",
    "fontWeight": "500",
    "fontSize": "0.42667rem",
    "lineHeight": "0.50667rem"
  },
  "amout": {
    "color": "rgb(17,17,17)",
    "fontFamily": "MTNewDigitalDisplay-Bold",
    "fontWeight": "700",
    "fontSize": "0.8rem",
    "lineHeight": "0.90667rem"
  },
  "amoutRight": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.4rem",
    "lineHeight": "0.56rem",
    "marginLeft": "0.02667rem"
  },
  "descContainer": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "flex-start"
  },
  "couponTitle": {
    "marginBottom": "0.10667rem",
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.42667rem",
    "lineHeight": "0.58667rem"
  },
  "couponDesc": {
    "height": "0.42667rem",
    "color": "rgb(85,85,85)",
    "fontFamily": "PingFang SC",
    "fontWeight": "400",
    "fontSize": "0.32rem",
    "lineHeight": "0.4rem"
  },
  "btnContainer": {
    "height": "1.04rem",
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "btn": {
    "width": "1.73333rem",
    "height": "0.64rem",
    "borderRadius": "6.13333rem",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "btnText": {
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.32rem"
  },
  "processContainer": {
    "marginTop": "0.16rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "height": "0.24rem"
  },
  "processBg": {
    "position": "relative",
    "width": "0.96rem",
    "height": "0.10667rem",
    "borderRadius": "0.10667rem",
    "backgroundColor": "rgb(255,241,240)"
  },
  "processTop": {
    "position": "absolute",
    "left": 0,
    "width": "0.66667rem",
    "height": "0.10667rem",
    "borderRadius": "0.10667rem",
    "backgroundColor": "rgb(255,75,16)"
  },
  "processText": {
    "marginLeft": "0.10667rem",
    "color": "rgb(255,75,16)",
    "fontFamily": "PingFang SC",
    "fontWeight": "400",
    "fontSize": "0.26667rem",
    "lineHeight": "0.34667rem"
  },
  "toUseText": {
    "marginTop": "0.16rem",
    "height": "0.26667rem",
    "color": "rgb(136,136,136)",
    "fontFamily": "PingFang SC",
    "fontWeight": "400",
    "fontSize": "0.26667rem",
    "lineHeight": "0.26667rem"
  }
};

  if (typeof FontFace === 'function') {
    
    var fontFace0 = new FontFace('MTNewDigitalDisplay-Bold', 'url("https://s3plus.meituan.net/tex-external-advertising/MTNewDigitalDisplay-Bold.otf") format("opentype")');
    document.fonts.add(fontFace0);
    
  }
    


  module.exports = _styles;
  